import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../Components/Button';
import handleTransformLang from '../functions/handleTransformLang';
import dealershipQueryPage from '../lang/pages/dealershipQuery.json';

export default function DealershipQuery() {
  const [trackingCode, setTrackingCode] = useState('');
  const [pageContent, setPageContent] = useState(handleTransformLang(dealershipQueryPage));

  useEffect(() => {
    const previousTitle = document.title;
    const translatedPage = handleTransformLang(dealershipQueryPage);
    const translatedHead = handleTransformLang(dealershipQueryPage.head);

    setPageContent(translatedPage);
    document.title = translatedHead.title;

    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <div className="min-h-screen bg-white p-2 sm:p-3">
      <section className="relative min-h-[calc(100vh-16px)] overflow-hidden bg-bg_secondary sm:min-h-[calc(100vh-24px)]">
        <div className="h-1.5 w-full bg-bg_primary" />

        <img
          src="/images/bg_footer.svg"
          alt=""
          className="pointer-events-none absolute bottom-0 right-0 w-[34rem] max-w-none opacity-[0.16] sm:w-[42rem] lg:w-[58rem]"
        />

        <Link
          to="/dealership"
          aria-label={pageContent.closeAriaLabel}
          className="absolute right-5 top-6 z-10 text-[2.4rem] leading-none text-bg_primary transition-colors duration-200 hover:text-orange-300 sm:right-8 sm:top-8 sm:text-[3rem]"
        >
          ×
        </Link>

        <div className="relative z-10 flex min-h-[calc(100vh-16px)] flex-col px-6 py-12 sm:min-h-[calc(100vh-24px)] sm:px-10 sm:py-16 lg:px-24 lg:py-18">
          <div className="w-fit">
            <img
              src="/images/footer_logo.svg"
              alt=""
              className="h-auto w-[11rem] sm:w-[13rem] lg:w-[14rem]"
            />
          </div>

          <div className="mt-14 max-w-[42rem] sm:mt-18 lg:mt-20">
            <h1 className="text-[31px] font-bold leading-[1.15] text-white sm:text-[38px] lg:text-[43px]">
              {pageContent.title}
            </h1>

            <p className="mt-4 max-w-[48rem] text-[14px] leading-7 text-white/90 sm:text-[15px] lg:text-[17px] lg:leading-8">
              {pageContent.description}
            </p>

            <form
              className="mt-16 flex max-w-[19rem] flex-col items-start gap-9 sm:mt-20 sm:max-w-[21rem]"
              onSubmit={(event) => event.preventDefault()}
            >
              <input
                type="text"
                value={trackingCode}
                onChange={(event) => setTrackingCode(event.target.value)}
                placeholder={pageContent.placeholder}
                className="h-[3.1rem] w-full border-0 bg-white px-4 text-[15px] text-text_secondary ring-1 ring-[#c6c9d1] placeholder:text-[#a0a8b8] focus:outline-none focus:ring-2 focus:ring-[#d0d6e2]"
              />

              <Button type="submit" className="min-w-[9.5rem] px-0 sm:min-w-[10rem]">
                {pageContent.buttonLabel}
              </Button>
            </form>
          </div>

          <div className="mt-auto flex justify-center pt-16 sm:justify-end">
            <a
              href="https://b2b.bulutmarket.com.tr"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex min-h-[5.5rem] min-w-[13rem] items-center gap-4 rounded-[10px] bg-[#e7852f] px-6 py-4 text-white transition-colors duration-200 hover:bg-[#ef8d35] sm:min-h-[5.8rem] sm:min-w-[14.5rem] sm:px-7"
            >
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-full border-2 border-white">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.1"
                  className="h-7 w-7 transition-transform duration-200 group-hover:translate-x-0.5"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="m12 5 7 7-7 7" />
                </svg>
              </span>

              <span className="text-left text-[1.05rem] font-bold leading-[1.05] sm:text-[1.15rem]">
                <span className="block">{pageContent.b2b.top}</span>
                <span className="block">{pageContent.b2b.bottom}</span>
              </span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
